// リクエストAPI URL
export const REQUEST_API_URL = import.meta.env.VITE_APP_REQUEST_API_URL;
export const REQUEST_API_URL_WITHOUT_API_V1 = import.meta.env.VITE_APP_REQUEST_API_URL.replace(
  /\/api\/v1$/,
  ''
);

export const API_CLIENT_KEY = 'fukuri-admins-api';

// Sentry設定
export const SENTRY_CONFIG = {
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
} as const;
